(() => {
  const MATERIALS = {
    alveolaire: {
      label: 'Polycarbonate alvéolaire',
      thicknesses: ['4 mm', '6 mm', '8 mm', '10 mm', '16 mm', '32 mm', '35 mm', '55 mm'],
      rotation: false,
      rule: '<strong>Sens des alvéoles obligatoire :</strong> les pièces ne sont jamais tournées à 90°. La longueur saisie doit suivre le sens des alvéoles et la pente.',
      formats: [
        { id: 'a6000', length: 6000, width: 2100, price: 0 },
        { id: 'a7000', length: 7000, width: 2100, price: 0 }
      ]
    },

    compact: {
      label: 'Polycarbonate compact',
      thicknesses: ['2 mm', '3 mm', '4 mm', '5 mm', '6 mm', '8 mm', '10 mm', '12 mm'],
      rotation: true,
      rule: '<strong>Plaques standards avec découpe :</strong> le client paie chaque plaque entière utilisée. Le forfait de découpe est ajouté par plaque standard découpée.',
      formats: [
        { id: 'c3050', length: 3050, width: 2050, price: 0 },
        { id: 'c4200', length: 4200, width: 2050, price: 0 },
        { id: 'c6100', length: 6100, width: 2050, price: 0 },
        { id: 'c7000', length: 7000, width: 2100, price: 0 }
      ]
    },

    pmma: {
      label: 'Plexiglas / PMMA',
      thicknesses: ['2 mm', '3 mm', '4 mm', '5 mm', '6 mm', '8 mm', '10 mm', '12 mm', '15 mm', '20 mm'],
      rotation: true,
      rule: '<strong>Plaques standards avec découpe :</strong> le client paie chaque plaque entière utilisée. Le forfait de découpe est ajouté par plaque standard découpée.',
      formats: [
        { id: 'p3050', length: 3050, width: 2050, price: 0 },
        { id: 'p4050', length: 4050, width: 2050, price: 0 }
      ]
    }
  };

  const KERF = 0;

  const money = (value) =>
    new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(value);

  const area = (mm2) =>
    `${(mm2 / 1000000).toLocaleString('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })} m²`;

  class CalepinageApp {
    constructor(root) {
      this.root = root;
      this.cutFee = Number(root.dataset.cutFee || 10);

      this.material = root.querySelector('[data-field="material"]');
      this.thickness = root.querySelector('[data-field="thickness"]');
      this.rotation = root.querySelector('[data-field="rotation"]');
      this.rotationWrap = root.querySelector('[data-role="rotation-wrap"]');
      this.materialRule = root.querySelector('[data-role="material-rule"]');
      this.piecesBody = root.querySelector('[data-role="pieces-body"]');
      this.formats = root.querySelector('[data-role="formats"]');
      this.results = root.querySelector('[data-role="results"]');

      this.bindEvents();
      this.addRow(3000, 1000, 4);
      this.addRow(3000, 1100, 4);
      this.updateMaterial();
    }

    bindEvents() {
      this.root.querySelector('[data-action="add-row"]').addEventListener('click', () => this.addRow());

      this.root.querySelector('[data-action="calculate"]').addEventListener('click', () => this.calculate());

      this.root.querySelector('[data-action="reset"]').addEventListener('click', () => this.reset());

      this.material.addEventListener('change', () => this.updateMaterial());
    }

    addRow(length = '', width = '', quantity = 1) {
      const row = document.createElement('tr');

      row.innerHTML = `
        <td><input type="number" min="1" step="1" value="${length}" placeholder="Ex. 2800" data-piece="length"></td>
        <td><input type="number" min="1" step="1" value="${width}" placeholder="Ex. 1050" data-piece="width"></td>
        <td><input type="number" min="1" step="1" value="${quantity}" data-piece="quantity"></td>
        <td><button type="button" class="calepinage-remove" aria-label="Supprimer">×</button></td>
      `;

      row.querySelector('.calepinage-remove').addEventListener('click', () => {
        if (this.piecesBody.children.length > 1) row.remove();
      });

      this.piecesBody.appendChild(row);
    }

    updateMaterial() {
      const current = MATERIALS[this.material.value];

      this.thickness.innerHTML = current.thicknesses
        .map((thickness) => `<option value="${thickness}">${thickness}</option>`)
        .join('');

      this.materialRule.innerHTML = current.rule;

      this.rotation.checked = current.rotation;
      this.rotation.disabled = !current.rotation;
      this.rotationWrap.style.opacity = current.rotation ? '1' : '.55';

      this.formats.innerHTML = current.formats
        .map((format, index) => {
          const checked = index < 2 || current.formats.length <= 2;

          return `
            <label class="calepinage-format ${checked ? 'is-selected' : ''}">
              <input type="checkbox" value="${format.id}" ${checked ? 'checked' : ''}>
              <span>
                <strong>${format.length} × ${format.width} mm</strong>
                <small>${format.price > 0 ? `${money(format.price)} / plaque entière` : 'Tarif matière à configurer'}</small>
              </span>
            </label>
          `;
        })
        .join('');

      this.formats.querySelectorAll('input').forEach((input) => {
        input.addEventListener('change', () => {
          input.closest('.calepinage-format').classList.toggle('is-selected', input.checked);
        });
      });

      this.results.hidden = true;
    }

    readPieces() {
      const pieces = [];
      let typeIndex = 1;

      this.piecesBody.querySelectorAll('tr').forEach((row) => {
        const length = Number(row.querySelector('[data-piece="length"]').value);
        const width = Number(row.querySelector('[data-piece="width"]').value);
        const quantity = Number(row.querySelector('[data-piece="quantity"]').value);

        if (!length || !width || !quantity || length <= 0 || width <= 0 || quantity <= 0) return;

        for (let index = 0; index < quantity; index += 1) {
          pieces.push({
            id: `T${typeIndex}-${index + 1}`,
            label: `${length} × ${width}`,
            length,
            width,
            area: length * width
          });
        }

        typeIndex += 1;
      });

      return pieces;
    }

    selectedFormats() {
      const current = MATERIALS[this.material.value];
      const selectedIds = [...this.formats.querySelectorAll('input:checked')].map((input) => input.value);

      return current.formats.filter((format) => selectedIds.includes(format.id));
    }

    packOneSheet(pieces, format, canRotate) {
      const freeRects = [{ x: 0, y: 0, width: format.length, height: format.width }];
      const placed = [];
      const remaining = [...pieces];

      const prune = (rectangles) =>
        rectangles.filter(
          (a, i) =>
            !rectangles.some(
              (b, j) =>
                i !== j &&
                a.x >= b.x &&
                a.y >= b.y &&
                a.x + a.width <= b.x + b.width &&
                a.y + a.height <= b.y + b.height
            )
        );

      let found = true;

      while (found) {
        found = false;
        let best = null;

        for (let pieceIndex = 0; pieceIndex < remaining.length; pieceIndex += 1) {
          const piece = remaining[pieceIndex];
          const orientations = [
            {
              width: piece.length,
              height: piece.width,
              rotated: false
            }
          ];

          if (canRotate && piece.length !== piece.width) {
            orientations.push({
              width: piece.width,
              height: piece.length,
              rotated: true
            });
          }

          for (let rectIndex = 0; rectIndex < freeRects.length; rectIndex += 1) {
            const rect = freeRects[rectIndex];

            orientations.forEach((orientation) => {
              if (orientation.width <= rect.width && orientation.height <= rect.height) {
                const shortSide = Math.min(
                  rect.width - orientation.width,
                  rect.height - orientation.height
                );

                const longSide = Math.max(
                  rect.width - orientation.width,
                  rect.height - orientation.height
                );

                const score = shortSide * 100000 + longSide;

                if (!best || score < best.score) {
                  best = {
                    pieceIndex,
                    rectIndex,
                    orientation,
                    score
                  };
                }
              }
            });
          }
        }

        if (!best) continue;

        const piece = remaining.splice(best.pieceIndex, 1)[0];
        const rect = freeRects.splice(best.rectIndex, 1)[0];
        const orientation = best.orientation;

        placed.push({
          ...piece,
          x: rect.x,
          y: rect.y,
          placedLength: orientation.width,
          placedWidth: orientation.height,
          rotated: orientation.rotated
        });

        const rightWidth = rect.width - orientation.width - KERF;
        const bottomHeight = rect.height - orientation.height - KERF;

        if (rightWidth > 0) {
          freeRects.push({
            x: rect.x + orientation.width + KERF,
            y: rect.y,
            width: rightWidth,
            height: orientation.height
          });
        }

        if (bottomHeight > 0) {
          freeRects.push({
            x: rect.x,
            y: rect.y + orientation.height + KERF,
            width: rect.width,
            height: bottomHeight
          });
        }

        const cleaned = prune(freeRects);
        freeRects.length = 0;
        freeRects.push(...cleaned);
        found = true;
      }

      return { placed, remaining };
    }

    optimize(pieces, formats, canRotate) {
      let remaining = [...pieces].sort(
        (a, b) =>
          Math.max(b.length, b.width) - Math.max(a.length, a.width) ||
          b.area - a.area
      );

      const sheets = [];

      while (remaining.length) {
        let best = null;

        formats.forEach((format) => {
          const trial = this.packOneSheet(remaining, format, canRotate);

          if (!trial.placed.length) return;

          const usedArea = trial.placed.reduce((sum, piece) => sum + piece.area, 0);
          const sheetArea = format.length * format.width;
          const fillRate = usedArea / sheetArea;
          const priceWeight = format.price > 0 ? format.price : sheetArea / 1000000;

          const score =
            trial.placed.length * 1000000000 +
            fillRate * 1000000 -
            priceWeight;

          if (!best || score > best.score) {
            best = {
              format,
              trial,
              score,
              usedArea,
              sheetArea
            };
          }
        });

        if (!best) {
          return {
            ok: false,
            error:
              'Au moins une pièce est plus grande que tous les formats sélectionnés. Sélectionnez un format compatible ou réduisez ses dimensions.'
          };
        }

        sheets.push({
          format: best.format,
          pieces: best.trial.placed,
          usedArea: best.usedArea,
          sheetArea: best.sheetArea
        });

        remaining = best.trial.remaining;
      }

      const usedArea = sheets.reduce((sum, sheet) => sum + sheet.usedArea, 0);
      const boughtArea = sheets.reduce((sum, sheet) => sum + sheet.sheetArea, 0);
      const materialPrice = sheets.reduce((sum, sheet) => sum + (sheet.format.price || 0), 0);
      const cutFee = sheets.length * this.cutFee;

      return {
        ok: true,
        sheets,
        usedArea,
        boughtArea,
        wasteArea: boughtArea - usedArea,
        wasteRate: boughtArea ? ((boughtArea - usedArea) / boughtArea) * 100 : 0,
        materialPrice,
        cutFee,
        totalPrice: materialPrice + cutFee
      };
    }

    calculate() {
      const pieces = this.readPieces();
      const formats = this.selectedFormats();

      if (!pieces.length) {
        this.showError('Ajoutez au moins une dimension et une quantité valides.');
        return;
      }

      if (!formats.length) {
        this.showError('Sélectionnez au moins un format de plaque.');
        return;
      }

      const current = MATERIALS[this.material.value];
      const canRotate = current.rotation && this.rotation.checked;
      const result = this.optimize(pieces, formats, canRotate);

      this.render(result, pieces.length);
    }

    showError(message) {
      this.results.hidden = false;
      this.root.querySelector('[data-role="alert"]').innerHTML =
        `<div class="calepinage-alert-error">${message}</div>`;
      this.root.querySelector('[data-role="diagrams"]').innerHTML = '';
      this.results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    render(result, pieceCount) {
      this.results.hidden = false;

      if (!result.ok) {
        this.showError(result.error);
        return;
      }

      const badge = this.root.querySelector('[data-role="badge"]');

      badge.textContent =
        result.wasteRate <= 10
          ? 'TRÈS BON RENDEMENT'
          : result.wasteRate <= 25
            ? 'CALEPINAGE OPTIMISÉ'
            : 'CHUTES À SURVEILLER';

      this.root.querySelector('[data-role="alert"]').innerHTML = `
        <div class="calepinage-alert-ok">
          Le calculateur a réparti <strong>${pieceCount} pièce${pieceCount > 1 ? 's' : ''}</strong>
          dans <strong>${result.sheets.length} plaque${result.sheets.length > 1 ? 's' : ''} entière${result.sheets.length > 1 ? 's' : ''}</strong>.
        </div>
      `;

      this.root.querySelector('[data-stat="pieces"]').textContent = pieceCount;
      this.root.querySelector('[data-stat="sheets"]').textContent = result.sheets.length;
      this.root.querySelector('[data-stat="used"]').textContent = area(result.usedArea);
      this.root.querySelector('[data-stat="bought"]').textContent = area(result.boughtArea);
      this.root.querySelector('[data-stat="waste"]').textContent =
        `${result.wasteRate.toLocaleString('fr-FR', { maximumFractionDigits: 1 })} %`;
      this.root.querySelector('[data-stat="cut"]').textContent = money(result.cutFee);

      const counts = {};

      result.sheets.forEach((sheet) => {
        const key = `${sheet.format.length} × ${sheet.format.width} mm`;
        counts[key] = (counts[key] || 0) + 1;
      });

      this.root.querySelector('[data-role="sheet-summary"]').innerHTML =
        Object.entries(counts)
          .map(
            ([name, count]) => `
              <div class="calepinage-summary-line">
                <span>${name}</span>
                <strong>${count} plaque${count > 1 ? 's' : ''}</strong>
              </div>
            `
          )
          .join('') +
        `
          <div class="calepinage-summary-line">
            <span>Surface de chute estimée</span>
            <strong>${area(result.wasteArea)}</strong>
          </div>
        `;

      const hasPrices = result.sheets.some((sheet) => sheet.format.price > 0);

      this.root.querySelector('[data-role="price-summary"]').innerHTML = hasPrices
        ? `
            <div class="calepinage-summary-line">
              <span>Plaques entières</span>
              <strong>${money(result.materialPrice)}</strong>
            </div>

            <div class="calepinage-summary-line">
              <span>Découpe (${result.sheets.length} × ${money(this.cutFee)})</span>
              <strong>${money(result.cutFee)}</strong>
            </div>

            <div class="calepinage-summary-line calepinage-summary-total">
              <span>Total estimé</span>
              <strong>${money(result.totalPrice)}</strong>
            </div>
          `
        : `
            <div class="calepinage-summary-line">
              <span>Prix matière</span>
              <strong>À configurer</strong>
            </div>

            <div class="calepinage-summary-line">
              <span>Découpe (${result.sheets.length} × ${money(this.cutFee)})</span>
              <strong>${money(result.cutFee)}</strong>
            </div>

            <p class="calepinage-help">
              Ajoutez vos prix dans <strong>calepinage.js</strong>, dans la propriété <strong>price</strong> de chaque format.
            </p>
          `;

      this.root.querySelector('[data-role="diagrams"]').innerHTML = result.sheets
        .map((sheet, index) => {
          const cuts = sheet.pieces
            .map((piece) => {
              const left = (piece.x / sheet.format.length) * 100;
              const top = (piece.y / sheet.format.width) * 100;
              const width = (piece.placedLength / sheet.format.length) * 100;
              const height = (piece.placedWidth / sheet.format.width) * 100;

              return `
                <div
                  class="calepinage-cut"
                  style="left:${left}%;top:${top}%;width:${width}%;height:${height}%"
                  title="${piece.label} mm${piece.rotated ? ' – tournée à 90°' : ''}"
                >
                  ${piece.label}${piece.rotated ? ' ↻' : ''}
                </div>
              `;
            })
            .join('');

          const fillRate = (sheet.usedArea / sheet.sheetArea) * 100;

          return `
            <article class="calepinage-diagram">
              <h3>Plaque ${index + 1} — ${sheet.format.length} × ${sheet.format.width} mm</h3>

              <div class="calepinage-sheet">
                ${cuts}
              </div>

              <div class="calepinage-diagram-meta">
                <span>${sheet.pieces.length} pièce${sheet.pieces.length > 1 ? 's' : ''}</span>
                <span>${fillRate.toLocaleString('fr-FR', { maximumFractionDigits: 1 })}% utilisé</span>
              </div>
            </article>
          `;
        })
        .join('');

      this.results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    reset() {
      this.piecesBody.innerHTML = '';
      this.addRow();
      this.addRow();
      this.material.value = 'alveolaire';
      this.updateMaterial();

      this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

    const init = () => {
    document.querySelectorAll('[data-calepinage-app]').forEach((root) => {
      if (root.dataset.initialized === 'true') return;

      root.dataset.initialized = 'true';
      new CalepinageApp(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
